import React from 'react'
import { SVGProps } from 'react'

const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={59}
    height={43}
    viewBox="0 0 59 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M56.9029 8.99707L24.9443 40.9548C23.9855 41.9136 22.7269 42.3961 21.4683 42.3961C20.2097 42.3961 18.9512 41.9136 17.9924 40.9548L2.01352 24.9759C0.0905457 23.0539 0.0905457 19.9461 2.01352 18.0241C3.93559 16.1011 7.04242 16.1011 8.96539 18.0241L21.4683 30.527L49.951 2.0452C51.8731 0.122223 54.9799 0.122223 56.9029 2.0452C58.825 3.96727 58.825 7.0741 56.9029 8.99707Z" />
  </svg>
)
export default CheckIcon
